import { useNavigate } from 'react-router-dom';
import { useUser, useClerk, OrganizationSwitcher } from '@clerk/react';
import { useTheme } from '../services/theme';
import { IconGrid, IconActivity, IconUser, IconUsers, IconSun, IconMoon } from './icons';

const NAV_ITEMS = [
  { key: 'dashboard', label: 'Dashboard', icon: IconGrid, path: '/dashboard' },
  { key: 'logs', label: 'Logs', icon: IconActivity, path: '/logs' },
  { key: 'team', label: 'Team', icon: IconUsers, path: '/team' },
  { key: 'profile', label: 'Profile', icon: IconUser, path: '/profile' },
];

export default function Sidebar({ active }) {
  const navigate = useNavigate();
  const { user } = useUser();
  const { signOut } = useClerk();
  const [theme, toggleTheme] = useTheme();

  return (
    <div className="flex w-56 shrink-0 flex-col border-r border-border2 bg-surface">
      <div className="flex items-center gap-2.5 border-b border-border2 px-4 py-5">
        <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-accent font-display text-sm font-extrabold text-white">M</div>
        <span className="font-display text-[15px] font-bold">Mail<span className="text-accent">Cutover</span></span>
      </div>

      <nav className="flex-1 p-2 pt-3">
        {NAV_ITEMS.map(({ key, label, icon: Icon, path }) => (
          <div key={key} onClick={() => navigate(path)}
            className={`mb-0.5 flex cursor-pointer items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
              active === key ? 'bg-accent/10 text-accent' : 'text-muted hover:bg-surface2 hover:text-ink'
            }`}>
            <Icon />
            {label}
          </div>
        ))}
      </nav>

      <div className="border-t border-border2 p-3">
        <div className="mb-2">
          <OrganizationSwitcher
            hidePersonal={false}
            afterCreateOrganizationUrl="/dashboard"
            afterSelectOrganizationUrl="/dashboard"
            afterSelectPersonalUrl="/dashboard"
            afterLeaveOrganizationUrl="/dashboard"
            appearance={{ elements: { rootBox: 'w-full', organizationSwitcherTrigger: 'w-full justify-between px-2 py-1.5 rounded-md hover:bg-surface2' } }}
          />
        </div>
        <button onClick={toggleTheme}
          className="mb-2 flex w-full items-center gap-2 rounded-md p-2 text-xs font-medium text-muted transition-colors hover:bg-surface2 hover:text-ink">
          {theme === 'dark' ? <IconSun /> : <IconMoon />}
          {theme === 'dark' ? 'Light mode' : 'Dark mode'}
        </button>
        <div className="flex cursor-pointer items-center gap-2 rounded-md p-2 hover:bg-surface2" onClick={() => signOut()}>
          <div className="flex h-7 w-7 items-center justify-center rounded-full bg-gradient-to-br from-special to-accent text-[11px] font-bold text-white">
            {user?.fullName?.[0] || 'A'}
          </div>
          <div>
            <div className="text-xs font-semibold leading-tight">{user?.fullName}</div>
            <div className="text-[10px] leading-tight text-dim">Sign out</div>
          </div>
        </div>
      </div>
    </div>
  );
}
